import * as React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./ResidentModal.css";
import { Grid } from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import TextField from "@mui/material/TextField";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import ResidentStatusListingsearch from "../listings/ResidentStatusListingsearch";
import { useEffect } from "react";
import {
  getresidentStatusUserSearch,
} from "../common/constants/globalconstants";
import { useSelector } from "react-redux";
import SSNTextField from "../common/SSNTextField";
import ErrorModal from "../common/ErrorModal";
import axiosInstance from "../common/AxiosInterceptor";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  padding: "20px !important",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  maxHeight: "80%",
  overflowY: "auto",
  borderRadius:"5px"
};

export default function SearchModal(props) {
  const [showSSN, setShowSSN] = useState(false);
  const [errormodalopen, seterrormodalOpen] = React.useState(false);

  //const storetoken = useSelector((state) => state.storetoken);
  const [hasFocus, setFocus] = useState(false);
  const [records, setRecords] = useState([]);
  const [loading, setloading] = useState(false); 
  const [resetPagination, setRstpagination] = useState(false);

  const storeuser = useSelector((state) => state.storeuser);
  //const carefacilitydetails = useSelector((state) => state.carefacilitydetails);

  const searchresident = async() => {
    setRstpagination(!resetPagination);
    setloading(true);
    const request =  {
      userName: storeuser.email, //storeuser.
      payeeFirstName: residentfields.fname,
      payeeLastName: residentfields.lname,
      ssn: residentfields.ssn,
    }
    try{
    const resp = await axiosInstance.post(`${getresidentStatusUserSearch}`, request);
        if(resp.data.isSuccess){
        const dataWithIds = resp.data.result.map((record) => ({
          ...record,
          rowKey: uuidv4(),
        }));

        setRecords(dataWithIds);
        setloading(false);
        seterrormodalOpen(false);
      }
      else if(!resp.data.isSuccess){
        seterrormodalOpen(true);
      }
      setloading(false);
      }
      catch(err) {
        console.log(err.message);
        seterrormodalOpen(true);
        setloading(false);
      };
  };

  const searchresidentinitial = async() => {
    setloading(true);
    const request = {
      userName: storeuser.email, //storeuser.
      payeeFirstName: "",
      payeeLastName: "",
      ssn: "",
    };
    try{
      const resp = await axiosInstance.post(`${getresidentStatusUserSearch}`, request);
      if(resp.data.isSuccess){
        const dataWithIds = resp.data.result.map((record) => ({
          ...record,
          rowKey: uuidv4(),
        }));
        setRecords(dataWithIds);
        //setTableData(resp.data.result);
        setloading(false);
        seterrormodalOpen(false);
      }
      else if(!resp.data.isSuccess){
        seterrormodalOpen(true);
      }
      setloading(false);
      }
      catch(err) {
        console.log(err.message);
        seterrormodalOpen(true);
        setloading(false);
      };
  };
  useEffect(() => {
    searchresidentinitial();
  }, [storeuser.email]);

  const searchResidentRecord = async() => {
    setloading(true);
    const request = {
      userName: storeuser.email, //storeuser.
      payeeFirstName: "",
      payeeLastName: "",
      ssn: "",
    };
    try{
      const resp = await axiosInstance.post(`${getresidentStatusUserSearch}`, request);
      if(resp.data.isSuccess){
        const dataWithIds = resp.data.result.map((record) => ({
          ...record,
          rowKey: uuidv4(),
        }));
        setRecords(dataWithIds);
        seterrormodalOpen(false);
      }
      else if(!resp.data.isSuccess){
        seterrormodalOpen(true);
      }
      setloading(false);
      }
      catch(err) {
        console.log(err.message);
        setloading(false);
        seterrormodalOpen(true);
      };
  };

  //new changes below

  const [residentfields, setFields] = useState({
    fname: "",
    lname: "",
    ssn: "",
  });
  const handlemyInput = (e) => {
    e.preventDefault();
    const regex = /^[0-9]*$/;
    if (e.target.name === "ssn") {
      const value = e.target.value;
      if (regex.test(value)) {
        setFields({ ...residentfields, ssn: value });
      }
    } else {
      setFields({ ...residentfields, [e.target.name]: e.target.value });
    }
  };
  const handleReset = () => {
    setRstpagination(!resetPagination);
    setFields({ ...residentfields, fname: "", lname: "", ssn: "" });
    searchResidentRecord();
  };

  const handleOnBlur = (e) => {
    if (!e.target.value.trim()) {
      setFocus(false);
    }
  };

  const handleClickShowSSN = () => {
    setShowSSN(!showSSN);
  };
 
  const [contentsopen, setcontentsOpen] = React.useState("***********");
  
  return (
    <div>
      <Modal
        open={props.open}
        onClose={props.plzclose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="modalstyle"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h5" component="h2">
            User Search
            <IconButton
              aria-label="close"
              onClick={props.plzclose}
              sx={{
                position: "absolute",
                right: 35,
                top: 20,
                color: "white",
                backgroundColor: "red",
                padding: "2px",
                boxShadow: "none",
              }}
            >
              <CloseIcon />
            </IconButton>
          </Typography>
          <hr></hr>
          <br></br>
          <Grid
            item
            xs={7.7}
            sx={{
              p: "5px 16px",
              border: "1.5px solid #dfe3e8",
              borderRadius: "5px",
              backgroundColor: "white",
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%", height: "65px", m: "5px 0" }}
            >
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                  pr: "20px",
                }}
              >
                <p className="input-label">First Name</p>
                <TextField
                  variant="outlined"
                  margin="none"
                  label=""
                  placeholder="First Name"
                  name="fname"
                  value={residentfields.fname}
                  sx={{ width: "190px" }}
                  onChange={handlemyInput}
                  inputProps={{ className: "search-text" }}
                ></TextField>
              </Box>
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                }}
              >
                <p className="input-label">Last Name</p>
                <TextField
                  variant="outlined"
                  margin="none"
                  label=""
                  placeholder="Last Name"
                  onChange={handlemyInput}
                  value={residentfields.lname}
                  inputProps={{ className: "search-text" }}
                  name="lname"
                  sx={{ width: "190px"}}
                ></TextField>
              </Box>
            </Stack>
            <Divider
              variant="fullwidth"
              sx={{ backgroundColor: "#dfe3e8" }}
            ></Divider>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%", height: "65px", m: "5px 0" }}
            >
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                  pr: "20px",
                }}
              >
                <p className="input-label">SSN</p>
                <SSNTextField
                  name="ssn"
                  onChange={handlemyInput}
                  value={residentfields.ssn}
                  showSSN={showSSN}
                  setFocus={setFocus}
                  handleOnBlur={handleOnBlur}
                  handleClickShowSSN={handleClickShowSSN}
                  editable="Yes"
                />
              </Box>

              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                  paddingLeft: "25px",
                }}
              >
                <Button variant="contained" id="btn10" onClick={searchresident}>
                  Search
                </Button>
              </Box>

              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                }}
              >
                <Button
                  variant="outlined"
                  sx={{
                    width: "120px !important",
                    height: "40px",
                    marginLeft: "10px",
                    textTransform: "unset !important",
                  }}
                  onClick={handleReset}
                >
                  Reset
                </Button>
              </Box>
            </Stack>
          </Grid>

          <br></br>
          <ResidentStatusListingsearch
            ssnfunc={setcontentsOpen}
            loading={loading}
            getData={props.getData}
            plzclose={props.plzclose}
            records={records}
            resetPagination={resetPagination}
          />
        </Box>
      </Modal>
      {errormodalopen && (
        <ErrorModal open={true} onClose={() => seterrormodalOpen(false)} />
      )}
    </div>
  );
}
